import * as React from 'react'

/**
 * #1233 (guard G7): while `dirty`, closing or reloading the browser tab asks first. Browsers show their own wording;
 * the handler only has to cancel the event. `Dialog` and `Drawer` call this for their `dirty` prop, so a form wired
 * to either needs nothing more.
 */
export function useWarnOnUnload(dirty: boolean) {
  React.useEffect(() => {
    if (!dirty) return
    const onBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault()
      // Older Chromium/Safari still read returnValue.
      event.returnValue = ''
    }
    window.addEventListener('beforeunload', onBeforeUnload)
    return () => window.removeEventListener('beforeunload', onBeforeUnload)
  }, [dirty])
}
